import React from "react";
import { MdClose } from "react-icons/md";

const namedColors = {
  default: "#64748b",
  primary: "var(--primaryColor)",
  secondary: "#6d5ae6",
  error: "#e5484d",
  success: "#16a34a",
  warning: "#f57c00",
  info: "#0288d1",
};

const withAlpha = (color, alpha) =>
  color && !color.startsWith("var(") ? `${color}${alpha}` : color;

const Chip = ({
  children,
  label,
  color,
  selected,
  onClick,
  onDelete,
  size = "sm",
  dot,
  variant = "outlined",
  className = "",
  ...rest
}) => {
  const sizeClasses = {
    xs: "px-2 py-0.5 text-[10px]",
    sm: "px-2.5 py-1 text-xs",
    md: "px-3 py-1.5 text-sm",
    small: "px-2.5 py-1 text-xs",
    medium: "px-3 py-1.5 text-sm",
  };

  const resolvedColor = color ? namedColors[color] || color : undefined;
  const filled = selected || variant === "filled";

  const filledClasses = "border-transparent shadow-sm";
  const outlinedClasses =
    "bg-farmazon-surface border-farmazon-border text-farmazon-text-muted hover:bg-farmazon-hover";

  const colorStyle =
    filled && resolvedColor
      ? {
          backgroundColor: withAlpha(resolvedColor, "18"),
          color: resolvedColor,
          borderColor: withAlpha(resolvedColor, "30"),
        }
      : {};

  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium border transition-all duration-150 whitespace-nowrap ${
        onClick ? "cursor-pointer" : ""
      } ${sizeClasses[size] || sizeClasses.sm} ${filled ? filledClasses : outlinedClasses} ${className}`}
      style={colorStyle}
      {...rest}
    >
      {dot && (
        <span
          className="w-2 h-2 rounded-full flex-shrink-0"
          style={{ backgroundColor: resolvedColor || "#64748b" }}
        />
      )}
      {children ?? label}
      {onDelete && (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onDelete(event);
          }}
          className="-mr-1 flex items-center justify-center rounded-full p-0.5 hover:bg-black/10"
        >
          <MdClose size={14} />
        </button>
      )}
    </Tag>
  );
};

export default Chip;
